// import components
import PlanUnitSelector from '../PlanUnitSelector/PlanUnitSelector';
import { Controller } from 'react-hook-form';

// import types
import { ControlledPlanUnitSelectorProps } from './ControlledPlanUnitSelector.types';

export default function ControlledPlanUnitSelector<
  T extends boolean,
  U extends boolean
>({
  control,
  name,
  variant,
  size = 'small',
  ...planUnitSelectorProps
}: ControlledPlanUnitSelectorProps<T, U>) {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => {
        const disabled = field.disabled ? true : undefined;
        return (
          <PlanUnitSelector
            {...field}
            {...{ ref: undefined }}
            {...planUnitSelectorProps}
            disabled={disabled}
            defaultValue={field.value ? [field.value] : undefined}
            error={!!fieldState?.error?.type}
            helperText={fieldState?.error?.message}
            variant={variant}
            size={size}
            onSelected={(options) =>
              options.length > 0
                ? field.onChange(options[0])
                : field.onChange(null)
            }
          />
        );
      }}
    />
  );
}
